import React from 'react';
export const inputClass = 'w-full h-11 rounded-xl border border-line bg-raised px-3.5 text-sm text-white placeholder:text-muted/70 transition-colors duration-150 focus:border-neon focus:outline-none focus:ring-2 focus:ring-neon/25';
interface FormFieldProps {
  label: string;
  htmlFor: string;
  error?: string;
  optional?: boolean;
  className?: string;
  children: React.ReactNode;
}
export function FormField({
  label,
  htmlFor,
  error,
  optional,
  className = '',
  children
}: FormFieldProps) {
  return <div className={className} data-id="element-292" data-mp="2fat8lllggg8h">
      <label htmlFor={htmlFor} className="mb-1.5 flex items-baseline justify-between text-sm font-medium text-white" data-id="element-293" data-mp="2fbm7k0e6a1g2">
        {label}
        {optional && <span className="text-xs font-normal text-muted" data-id="element-294" data-mp="2p15rl9dmg1ci">Opcional</span>}
      </label>
      {children}
      {error && <p className="mt-1.5 text-xs text-red-400" role="alert" data-id="element-295" data-mp="3328e1n8j3dny">
          {error}
        </p>}
    </div>;
}